{
  "SEARCH": {
    "TABS": {
      "ALL": "All results",
      "CONTACTS": "കോൺ‌ടാക്റ്റുകൾ",
      "CONVERSATIONS": "സംഭാഷണങ്ങൾ",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "കോൺ‌ടാക്റ്റുകൾ",
      "CONVERSATIONS": "സംഭാഷണങ്ങൾ",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_SEARCHES": "Recent searches",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "Most recent",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "ബോട്ട്",
    "READ_MORE": "Read more",
    "READ_LESS": "Read less",
    "WROTE": "wrote:",
    "FROM": "From",
    "EMAIL": "ഇമെയിൽ",
    "EMAIL_SUBJECT": "Subject",
    "PRIVATE": "Private note",
    "TRANSCRIPT": "Transcript",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "updated {time}",
    "SORT_BY": {
      "RELEVANCE": "Relevance"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "കഴിഞ്ഞ 7 ദിവസം",
      "LAST_30_DAYS": "കഴിഞ്ഞ 30 ദിവസം",
      "LAST_60_DAYS": "കഴിഞ്ഞ 60 ദിവസം",
      "LAST_90_DAYS": "കഴിഞ്ഞ 90 ദിവസം",
      "CUSTOM_RANGE": "Custom range:",
      "CREATED_BETWEEN": "Created between",
      "AND": "and",
      "APPLY": "അപേക്ഷിക്കുക",
      "BEFORE_DATE": "Before {date}",
      "AFTER_DATE": "After {date}",
      "TIME_RANGE": "Filter by time",
      "CLEAR_FILTER": "Clear filter"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "Filter messages by:",
      "FROM": "അയച്ചയാൾ",
      "IN": "ഇൻബോക്സ്",
      "AGENTS": "ഏജന്റുമാർ",
      "CONTACTS": "കോൺ‌ടാക്റ്റുകൾ",
      "INBOXES": "ഇൻ‌ബോക്സുകൾ",
      "NO_AGENTS": "ഏജന്റകളെ ഒന്നും കണ്ടെത്താൻ സാധിച്ചില്ല",
      "NO_CONTACTS": "Start by searching to see results",
      "NO_INBOXES": "No inboxes found"
    }
  }
}
